import { take, map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LOAD_CONFIG_COMPLETE } from '../../actions/specification.actions';
import { IHaulerState } from '../../../location/reducers/hauler-reducer/hauler.reducer';
import { VehicleResp } from '@cemex-core/cmx-api/models/vehicles/vehicle-resp';
import { LoadVehiclesCompleteAction } from '../../actions/vehicle.actions';
import { getHaulerState, OrderBuilderState } from '../../../../reducers';
import { VehiclesService } from '@cemex-core/cmx-api';

@Injectable()
export class VehiclesEffects {
  vehicleLoad$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_CONFIG_COMPLETE),
      switchMap((payload: any) => {
        return this.store
          .select(getHaulerState)
          .pipe(take(1))
          .pipe(
            switchMap((haulerState: IHaulerState) => {
              return this.vehiclesService.getVehicles(haulerState.selected.haulerId).pipe(
                map((vehicleResponse: VehicleResp) => {
                  return new LoadVehiclesCompleteAction(vehicleResponse.vehicles);
                }),
              );
            }),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
    private vehiclesService: VehiclesService,
  ) {}
}
